
import React from 'react';
import {  DataGrid } from 'devextreme-react';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import {  createStore } from '../../utils/proxy';
import { Column, Editing, Lookup } from 'devextreme-react/data-grid';

const DetailTemplate = (props) => {

  const onInitNewRow = (e) => {
    e.data.itemId = props.data.data.id;
  }

  return (<>
    <div className="master-detail-caption">
      Proveedores
    </div>
    <DataGrid
      dataSource={store({ uri: uri.providersByItem(props.data.data.id) })}
      showBorders={true}
      columnAutoWidth={true}
      onInitNewRow={onInitNewRow}
    >
      <Editing
        allowDeleting={true}
        allowAdding={true}
        useIcons={true}
      >
      </Editing>
      <Column dataField="providerId" caption="Nombre proveedor">
        <Lookup disabled={true} dataSource={createStore({name :'provider'})} valueExpr="id" displayExpr="name" />
      </Column>     
    </DataGrid>
  </>

  );
};




function getProviders(data, providers) {

  if (data.itemProviders != null) {
    return providers.filter(x => data.itemProviders.some(p => p.providerId == x.id));
  }
  return [];
}

export default DetailTemplate;
